export default __webpack_public_path__ + "static/awareia-bg-56d747821e2b637a6f9de2e9de62f022.png";